export default function (context) {
    if (context.store.state.checkout.currentType && context.store.state.basket.deliveryDate) {
        return
    }

    context.redirect('/Cart')
}
